import React from 'react';
import { levels, systemMetrics } from '../data/content';
export function SystemOverview() {
  return <section aria-labelledby="system-heading" className="border-b border-navy-700 bg-navy" data-id="element-189" data-mp="18w2bntl9do2i">
      <div className="mx-auto max-w-page px-4 py-12 sm:px-5 lg:py-24" data-id="element-190" data-mp="1mn71y52ql406">
        <div className="max-w-3xl" data-id="element-191" data-mp="1hnkpvyyn9tsy">
          <span className="font-display text-[10px] font-bold uppercase tracking-[0.22em] text-gold sm:text-xs sm:tracking-[0.26em]" data-id="element-192" data-mp="1hnb1gft8zupd">
            The Blues Teacher’s Arsenal™
          </span>
          <h2 id="system-heading" className="mt-4 font-display text-2xl font-extrabold leading-[1.08] tracking-[-0.03em] text-white sm:mt-5 sm:text-[2.6rem]" data-id="element-193" data-mp="px6hgi9eh9oo">
            The most complete system for blues guitar educators
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-mist sm:mt-6 sm:text-lg" data-id="element-194" data-mp="2fbcmortsit00">
            Over 240 pages of complete lesson plans, professional exercises, regional style guides,
            and classroom management tools — everything already prepared for you.
          </p>
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-x-4 gap-y-6 border-y border-navy-700 py-7 sm:gap-y-8 sm:py-8 lg:mt-12 lg:grid-cols-4" data-id="element-195" data-mp="285gxdegkejf7">
          {systemMetrics.map(metric => <div key={metric.label} className="border-l-2 border-gold/40 pl-5" data-id="element-196" data-mp="2d2h8i3s9ucd6">
              <dt className="text-[11px] uppercase tracking-[0.14em] text-steel" data-id="element-197" data-mp="2i2vfdii4zg9m">{metric.label}</dt>
              <dd className="mt-1 font-display text-3xl font-extrabold tracking-[-0.03em] text-white sm:text-4xl" data-id="element-198" data-mp="1khpn0gel4ggk">
                {metric.value}
              </dd>
            </div>)}
        </dl>

        <div className="mt-14" data-id="element-199" data-mp="1ucr8n29nj0ee">
          <h3 className="font-display text-xs font-bold uppercase tracking-[0.26em] text-steel" data-id="element-200" data-mp="1z4itqxa1gdx5">
            Level coverage
          </h3>
          <ol className="mt-6 grid gap-x-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-201" data-mp="11olpgjy8xjgo">
            {levels.map(level => <li key={level.number} className="flex items-baseline gap-4 border-b border-navy-700 py-4" data-id="element-202" data-mp="16mn8x5zl3kso">
                <span className="font-display text-sm font-extrabold text-gold" data-id="element-203" data-mp="tp8r8kb5jrd9">
                  {level.number}
                </span>
                <span className="text-[15px] text-white" data-id="element-204" data-mp="18d25a0klaltq">{level.title}</span>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}